import Vue from 'vue';

const GAMES_SLUG: string = process.env.VUE_APP_ENABLE_GAMES_SLUG || '';

export default Vue.extend({
    computed: {
        configGame() {
            const gameSlugs: string[] = GAMES_SLUG.split(',');
            const gameConfigs: any[] = Object.values(this.$store.state.configAccount?.gameConfigs) || [];
            return gameSlugs.map(slug => gameConfigs.find((item: any) => item.slug === slug));
        },
        slugGames() {
            const result: string[] = [];
            this.configGame.forEach((item: any, id: number) => {
                result.push(item?.slug ? item?.slug : GAMES_SLUG.split(",")[id]);
            });
            return result;
        }
    }
});